import { Text, Button } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import ArrowRight from "@assets/icons/arrow-right.svg";

const FeatureSection = (props) => {
  return (
    <section className="w-full py-[48px] lg:py-[96px] container">
      <div className="w-full flex justify-center items-center">
        <div className="w-full aspect-video bg-gray-100 rounded-xl border border-gray-200 relative overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[60%] text-center flex flex-col items-center">
            <Text variant="text-5xl/leading-normal/medium" className="hidden md:block text-[#ECFF8C] mb-8">{props.title}</Text>

            <Button variant="primary" className="w-max" onClick={() => window.location.href = props.buttonLink}>
              {props.buttonText}
              <ArrowRight width={20} height={20} fill="#FFFFFF"/>
            </Button>
          </div>
          <img
            alt={props.alt || "Hero image"}
            src={props.src || "https://placehold.co/1200x1200"}
            className={"w-full h-full object-cover vb-rounded"}
          />
        </div>
      </div>      
    </section>
  );
};

FeatureSection.defaultProps = {
  src: "https://placehold.co/1200x900",
  alt: "scenic image",
  title: "Headline that solves user's main problem",
  buttonText: "Get started",
  buttonLink: "/",
};

FeatureSection.fields = {
  title: {
    type: "text",
    label: "Title",
  },
  buttonText: {
    type: "text",
    label: "Button text",
  },
  buttonLink: { type: "text", label: "Button link" },
  src: {
    type: "custom",
    label: "Image Source",
    render: ({ name, onChange, value }) => (
      <MediaSelector
        name={name}
        label="Image Source"
        type={"img"}
        onChange={onChange}
        value={value}
      />
    ),
  },
  alt: {
    type: "text",
    label: "Image Alt Text",
  },
};

export default FeatureSection;
